import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './web-application-security.css'

const WebApplicationSecurity = (props) => {
  return (
    <div className="web-application-security-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Web-Application-Security - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/web-application-security"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="web-application-security-hero-section hero-section">
        <video
          src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="hero-overlay"></div>
        <div className="web-application-security-hero-content hero-content">
          <div className="hero-text-wrapper">
            <div className="web-application-security-hero-badge">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>VAPT as a Service</span>
            </div>
            <h1 className="web-application-security-hero-title hero-title">
              Comprehensive Web Application Security Testing
            </h1>
            <p className="web-application-security-hero-subtitle hero-subtitle">
              Identify vulnerabilities before attackers do. Our enterprise-grade
              VAPT methodology ensures your web applications are fortified
              against OWASP Top 10 threats, zero-day exploits, and sophisticated
              attack vectors.
            </p>
            <div className="web-application-security-hero-stats">
              <div className="web-application-security-hero-stat-item">
                <div className="web-application-security-hero-stat-number">
                  <span>100+</span>
                </div>
                <div className="web-application-security-hero-stat-label">
                  <span>Web Apps Secured</span>
                </div>
              </div>
              <div className="web-application-security-hero-stat-item">
                <div className="web-application-security-hero-stat-number">
                  <span>99.8%</span>
                </div>
                <div className="web-application-security-hero-stat-label">
                  <span>Vulnerability Detection Rate</span>
                </div>
              </div>
              <div className="web-application-security-hero-stat-item">
                <div className="web-application-security-hero-stat-number">
                  <span>24/7</span>
                </div>
                <div className="web-application-security-hero-stat-label">
                  <span>Security Support</span>
                </div>
              </div>
            </div>
            <div className="hero-cta-group web-application-security-hero-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Security Assessment</span>
                </div>
              </a>
              <a href="#methodology">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Methodology</span>
                  
                </div>
              </a>
            </div>
            <div className="web-application-security-hero-trust-badges">
              <span className="web-application-security-hero-trust-item">
                ISO 27001 Certified
              </span>
              <span className="hero-trust-separator"></span>
              <span className="web-application-security-hero-trust-item">
                OWASP Compliant
              </span>
              <span className="hero-trust-separator"></span>
              <span className="web-application-security-hero-trust-item">
                PCI-DSS Approved
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="features-scope-section">
        <div className="features-scope-container">
          <div className="features-scope-header">
            <h2 className="section-title">What We Test</h2>
            <p className="section-subtitle">
              Comprehensive vulnerability assessment across your entire web
              application infrastructure
            </p>
          </div>
          <div className="features-scope-grid">
            <div className="features-scope-card">
              <div className="features-scope-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-scope-title">
                Application Attack Surface
              </h3>
              <p className="section-content">
                Deep analysis of authentication mechanisms, session management,
                input validation, and business logic flaws. We test every
                endpoint, parameter, and user interaction point.
              </p>
              <ul className="features-scope-list">
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>SQL Injection Detection</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>XSS Vulnerability Testing</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>CSRF Protection Analysis</span>
                </li>
              </ul>
            </div>
            <div className="features-scope-card">
              <div className="features-scope-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-scope-title">Security Configuration</h3>
              <p className="section-content">
                Evaluate server configurations, SSL/TLS implementation, security
                headers, cookie attributes, and CORS policies to ensure
                defense-in-depth protection.
              </p>
              <ul className="features-scope-list">
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>SSL/TLS Configuration</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Security Headers Assessment</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Cookie Security Review</span>
                </li>
              </ul>
            </div>
            <div className="features-scope-card">
              <div className="features-scope-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-scope-title">
                Business Logic &amp; Workflows
              </h3>
              <p className="section-content">
                Identify flaws in transaction handling, authorization bypasses,
                and race conditions that automated scanners miss. We think like
                attackers to break your business logic.
              </p>
              <ul className="features-scope-list">
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Authorization Bypass Testing</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Workflow Manipulation</span>
                </li>
                <li className="features-scope-list-item">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Rate Limiting Analysis</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="methodology" className="process-methodology-section">
        <div className="process-methodology-container">
          <div className="process-methodology-header">
            <h2 className="section-title">Our Testing Methodology</h2>
            <p className="section-subtitle">
              Industry-leading frameworks combined with real-world attack
              simulation
            </p>
          </div>
          <div className="process-methodology-steps">
            <div className="process-methodology-step">
              <div className="process-methodology-step-number">
                <span>01</span>
              </div>
              <div className="process-methodology-step-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="process-methodology-step-title">
                OWASP Testing Framework
              </h3>
              <p className="section-content">
                Comprehensive coverage of OWASP Top 10 vulnerabilities plus
                extended testing for API security, broken access control, and
                cryptographic failures using the latest WSTG methodology.
              </p>
            </div>
            <div className="process-methodology-connector">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-methodology-step">
              <div className="process-methodology-step-number">
                <span>02</span>
              </div>
              <div className="process-methodology-step-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-methodology-step-title">
                Automated SAST/DAST/SCA
              </h3>
              <p className="section-content">
                Leverage cutting-edge static, dynamic, and software composition
                analysis tools to identify vulnerabilities in source code,
                runtime behavior, and third-party dependencies at scale.
              </p>
            </div>
            <div className="process-methodology-connector">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <div className="process-methodology-step">
              <div className="process-methodology-step-number">
                <span>03</span>
              </div>
              <div className="process-methodology-step-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-methodology-step-title">
                Advanced Threat Modeling
              </h3>
              <p className="section-content">
                Manual security expert analysis to identify complex attack
                chains, business logic flaws, and zero-day vulnerabilities that
                require human intelligence and creative exploitation techniques.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="features-deliverables-section">
        <div className="features-deliverables-container">
          <div className="features-deliverables-header">
            <h2 className="section-title">Comprehensive Testing Coverage</h2>
            <p className="section-subtitle">
              Complete GLASS methodology for modern web application security
            </p>
          </div>
          <div className="features-deliverables-grid">
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                Web Application Testing
              </h3>
              <p className="section-content">
                Comprehensive OWASP-based testing covering injection attacks,
                broken authentication, sensitive data exposure, and all critical
                web vulnerabilities.
              </p>
            </div>
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                API Security Assessment
              </h3>
              <p className="section-content">
                REST, GraphQL, and SOAP API testing for authentication flaws,
                excessive data exposure, rate limiting issues, and injection
                vulnerabilities.
              </p>
            </div>
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                Microservices Security
              </h3>
              <p className="section-content">
                Container security, service mesh analysis, inter-service
                authentication, and distributed system vulnerability assessment
                for cloud-native architectures.
              </p>
            </div>
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                Executive Summary Report
              </h3>
              <p className="section-content">
                High-level risk assessment with business impact analysis,
                compliance mapping, and board-ready security posture overview
                with actionable recommendations.
              </p>
            </div>
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                Technical Deep Dive
              </h3>
              <p className="section-content">
                Detailed vulnerability documentation with proof-of-concept
                exploits, affected endpoints, CVSS scores, and step-by-step
                reproduction instructions.
              </p>
            </div>
            <div className="features-deliverables-card">
              <div className="features-deliverables-icon-wrapper">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-deliverables-title">
                Remediation Roadmap
              </h3>
              <p className="section-content">
                Prioritized fix strategies with timeline recommendations, secure
                coding examples, and architectural improvements to eliminate
                vulnerability classes.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-outcomes-section">
        <div className="stats-outcomes-container">
          <div className="stats-outcomes-header">
            <h2 className="section-title">Measurable Security Outcomes</h2>
            <p className="section-subtitle">
              Real impact on your security posture and risk reduction
            </p>
          </div>
          <div className="stats-outcomes-carousel-wrapper">
            <button
              id="statsCarouselPrev"
              aria-label="Previous outcome"
              className="stats-outcomes-carousel-prev stats-outcomes-carousel-btn"
            >
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="m12 19l-7-7l7-7m7 7H5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div className="stats-outcomes-carousel">
              <div
                id="statsCarouselTrack"
                className="stats-outcomes-carousel-track"
              >
                <div className="stats-outcomes-card-active stats-outcomes-card">
                  <div className="stats-outcomes-metric">
                    <span>85%</span>
                  </div>
                  <h3 className="stats-outcomes-label">Risk Reduction</h3>
                  <p className="section-content">
                    Average decrease in exploitable vulnerabilities within 60
                    days of implementing our remediation roadmap, significantly
                    reducing attack surface.
                  </p>
                </div>
                <div className="stats-outcomes-card">
                  <div className="stats-outcomes-metric">
                    <span>14 Days</span>
                  </div>
                  <h3 className="stats-outcomes-label">Faster Detection</h3>
                  <p className="section-content">
                    Identify critical vulnerabilities two weeks earlier than
                    traditional testing cycles, enabling proactive mitigation
                    before production deployment.
                  </p>
                </div>
                <div className="stats-outcomes-card">
                  <div className="stats-outcomes-metric">
                    <span>3.2x</span>
                  </div>
                  <h3 className="stats-outcomes-label">ROI Improvement</h3>
                  <p className="section-content">
                    Cost savings from preventing security incidents compared to
                    breach remediation expenses, insurance claims, and
                    regulatory penalties.
                  </p>
                </div>
                <div className="stats-outcomes-card">
                  <div className="stats-outcomes-metric">
                    <span>100%</span>
                  </div>
                  <h3 className="stats-outcomes-label">
                    Compliance Achievement
                  </h3>
                  <p className="section-content">
                    Meet PCI-DSS, SOC 2, ISO 27001, and GDPR security testing
                    requirements with comprehensive documentation and evidence
                    of due diligence.
                  </p>
                </div>
                <div className="stats-outcomes-card">
                  <div className="stats-outcomes-metric">
                    <span>24/7</span>
                  </div>
                  <h3 className="stats-outcomes-label">Expert Support</h3>
                  <p className="section-content">
                    Round-the-clock access to security consultants for
                    remediation guidance, emergency response, and clarification
                    on findings throughout engagement.
                  </p>
                </div>
              </div>
            </div>
            <button
              id="statsCarouselNext"
              aria-label="Next outcome"
              className="stats-outcomes-carousel-next stats-outcomes-carousel-btn"
            >
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M5 12h14m-7-7l7 7l-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <div
            id="statsCarouselIndicators"
            className="stats-outcomes-indicators"
          >
            <button
              aria-label="View outcome 1"
              data-index="0"
              className="stats-outcomes-indicator-active stats-outcomes-indicator"
            ></button>
            <button
              aria-label="View outcome 2"
              data-index="1"
              className="stats-outcomes-indicator"
            ></button>
            <button
              aria-label="View outcome 3"
              data-index="2"
              className="stats-outcomes-indicator"
            ></button>
            <button
              aria-label="View outcome 4"
              data-index="3"
              className="stats-outcomes-indicator"
            ></button>
            <button
              aria-label="View outcome 5"
              data-index="4"
              className="stats-outcomes-indicator"
            ></button>
          </div>
        </div>
      </section>
      <section className="web-application-security-case-studies-section">
        <div className="web-application-security-thq-case-studies-wrapper-elm web-application-security-case-studies-wrapper"></div>
      </section>
      <section
        id="contact"
        className="web-application-security-cta-engagement-section"
      >
        <div className="web-application-security-cta-engagement-container">
          <div className="cta-engagement-grid">
            <div className="web-application-security-thq-cta-engagement-card-elm web-application-security-cta-engagement-card cta-engagement-card-secondary">
              <div className="web-application-security-cta-engagement-icon">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5M9 15l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="web-application-security-cta-engagement-title">
                Request Security Assessment
              </h3>
              <p className="section-content">
                Get a comprehensive web application vulnerability assessment
                with detailed findings, risk analysis, and actionable
                remediation roadmap delivered within 2-3 weeks.
              </p>
              <a href="/contact-us">
                <div className="btn-accent btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <div className="web-application-security-cta-engagement-features">
                <div className="cta-engagement-feature-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>2-3 Week Turnaround</span>
                </div>
                <div className="cta-engagement-feature-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Executive &amp; Technical Reports</span>
                </div>
                <div className="cta-engagement-feature-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Compliance Documentation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="web-application-security-container2">
        <div className="web-application-security-container3">
          <Script
            html={`<script defer data-name="stats-carousel">
(function(){
  const track = document.getElementById("statsCarouselTrack")
  const prevBtn = document.getElementById("statsCarouselPrev")
  const nextBtn = document.getElementById("statsCarouselNext")
  const indicators = document.querySelectorAll(".stats-outcomes-indicator")
  const cards = document.querySelectorAll(".stats-outcomes-card")

  let currentIndex = 0
  const totalCards = cards.length

  function updateCarousel(index) {
    const offset = -index * 100
    track.style.transform = \`translateX(\${offset}%)\`

    cards.forEach((card, i) => {
      if (i === index) {
        card.classList.add("stats-outcomes-card-active")
      } else {
        card.classList.remove("stats-outcomes-card-active")
      }
    })

    indicators.forEach((indicator, i) => {
      if (i === index) {
        indicator.classList.add("stats-outcomes-indicator-active")
      } else {
        indicator.classList.remove("stats-outcomes-indicator-active")
      }
    })
  }

  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + totalCards) % totalCards
    updateCarousel(currentIndex)
  })

  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % totalCards
    updateCarousel(currentIndex)
  })

  indicators.forEach((indicator) => {
    indicator.addEventListener("click", (e) => {
      currentIndex = parseInt(e.target.dataset.index)
      updateCarousel(currentIndex)
    })
  })

  let autoplayInterval = setInterval(() => {
    currentIndex = (currentIndex + 1) % totalCards
    updateCarousel(currentIndex)
  }, 5000)

  document.querySelector(".stats-outcomes-carousel-wrapper").addEventListener("mouseenter", () => {
    clearInterval(autoplayInterval)
  })

  document.querySelector(".stats-outcomes-carousel-wrapper").addEventListener("mouseleave", () => {
    autoplayInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalCards
      updateCarousel(currentIndex)
    }, 5000)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default WebApplicationSecurity
